import React, { useContext, useEffect, useState } from "react";
import Loader from "../../components/Loader/Loader";
import { FcInfo } from "react-icons/fc";
import { CheckListContext } from "../../utils/checkListContext";
import "semantic-ui-css/semantic.min.css";
import Swal from "sweetalert2";
import QuestionSection from "../../components/questionSection";
import Form from "../../components/form";

export default function UserNewCheckQuestions({
  tableName,
  status,
  validateQuestions,
}) {
  const [def, setDef] = useState({});

  const {
    tempJSON,
    setTempJSON,
    setTotalQuestions,
    errors,
    setErrors,
    ratingMetadata,
    setRatingMetadata,
    checklistData,
  } = useContext(CheckListContext);

  let errorObj = errors;
  var errorReturn = "";

  useEffect(() => {
    let totalNo = checklistData
      ? checklistData.filter((item) => item.cat === tableName)?.length
      : "";
    setTotalQuestions((prev) => ({ ...prev, [tableName]: totalNo }));
  }, [tableName, checklistData]);

  useEffect(() => {
    let defValue = def;
    let ratingMetadataVar = ratingMetadata;
    let tempJSONVar = tempJSON;

    checklistData?.map(
      (defItem) => (
        (defValue = {
          ...defValue,
          [defItem["id"]]: tempJSON[defItem["id"]]
            ? tempJSON[defItem["id"]]
            : "",
        }),
        (ratingMetadataVar = {
          ...ratingMetadataVar,
          [defItem["id"]]: ratingMetadata?.[defItem["id"]]
            ? ratingMetadata?.[defItem["id"]]
            : "",
        }),
        (tempJSONVar = {
          ...tempJSONVar,
          [defItem["id"]]: tempJSONVar?.[defItem["id"]]
            ? tempJSONVar?.[defItem["id"]]
            : "",
        })
      )
    );
    setRatingMetadata(ratingMetadataVar);
    setDef((prev) => ({
      ...prev,
      rating_metadata: ratingMetadataVar,
    }));
    setTempJSON(tempJSONVar);
  }, [tableName, checklistData]);

  // const handleChange = (e, response, color, categoryName, index) => {
  //   !status &&
  //     setTempJSON((prev) => ({
  //       ...prev,
  //       [listData[index]["Check Points"]]: response,
  //     }));
  // };

  const handleChange = (e, response, item) => {
    const { name, value, type } = e.target;
    let rating_metadataVar = ratingMetadata;
    let tempJSONVar = tempJSON;
    let rangeObj = item["range"];
    if (item["input_type"] === 4 && !status) {
      rangeObj =
        rangeObj !== "-" && rangeObj !== "" && rangeObj
          ? JSON.parse(rangeObj)
          : undefined;
      if (rangeObj && value !== "") {
        let toggleAnswer = "";
        value &&
          (rating_metadataVar = { ...rating_metadataVar, [item["id"]]: value });
        if (
          rangeObj["ov_max"] !== rangeObj["ov_min"] &&
          rating_metadataVar[item["id"]] >= rangeObj["ov_min"] &&
          rating_metadataVar[item["id"]] <= rangeObj["ov_max"]
        ) {
          toggleAnswer = response;
        } else if (
          rangeObj["ov_max"] !== rangeObj["ov_min"] &&
          rating_metadataVar[item["id"]] >= rangeObj["min"] &&
          rating_metadataVar[item["id"]] < rangeObj["ov_min"]
        ) {
          toggleAnswer = "not_ok";
        } else if (
          rangeObj["ov_max"] !== rangeObj["ov_min"] &&
          rating_metadataVar[item["id"]] > rangeObj["ov_max"] &&
          rating_metadataVar[item["id"]] <= rangeObj["max"]
        ) {
          toggleAnswer = "ok";
        } else if (
          rangeObj["ov_max"] === rangeObj["ov_min"] &&
          rating_metadataVar[item["id"]] >= rangeObj["min"] &&
          rating_metadataVar[item["id"]] < rangeObj["ov_min"]
        ) {
          toggleAnswer = "not_ok";
        } else if (
          rangeObj["ov_max"] === rangeObj["ov_min"] &&
          rating_metadataVar[item["id"]] >= rangeObj["ov_max"] &&
          rating_metadataVar[item["id"]] <= rangeObj["max"]
        ) {
          toggleAnswer = "ok";
        }

        tempJSONVar = { ...tempJSONVar, [item["id"]]: toggleAnswer };
        setTempJSON(tempJSONVar);
        setRatingMetadata(rating_metadataVar);
        setDef((defItem) => ({
          ...defItem,
          rating_metadata: rating_metadataVar,
        }));
      } else if (response !== "" || value === "") {
        tempJSONVar = { ...tempJSONVar, [item["id"]]: value };
        setTempJSON(tempJSONVar);
        rating_metadataVar = { ...rating_metadataVar, [item["id"]]: value };
        setRatingMetadata(rating_metadataVar);
        setDef((defItem) => ({
          ...defItem,
          rating_metadata: rating_metadataVar,
        }));
      }
    } else if (!status && response !== "") {
      tempJSONVar = { ...tempJSONVar, [item["id"]]: response };
      setTempJSON(tempJSONVar);
    }
    let fieldValue = value ? value : tempJSONVar[item["id"]];
    errorReturn = validateQuestions(e, item["id"], fieldValue, item, errorObj);
    setErrors(errorReturn);
  };

  const toast = (e, message) => {
    Swal.fire({
      html: `<div style={{text-align:"center"}}>${message}</div>`,
      customClass: {
        container: "position-absolute",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      confirmButtonColor: "#652078",
      toast: true,
      confirmButtonText: "Close",
      position: "bottom-center",
    });
  };

  let Sr_No = 0;
  return (
    <>
      <div style={{ margin: "16px 0" }}>
        {!checklistData ? (
          <Loader />
        ) : (
          checklistData?.map((item, index) => {
            let rangeObj = "";
            rangeObj =
              item["range"] !== "-" ? JSON.parse(item["range"]) : undefined;
            return (
              item.visibility &&
              item["id"] &&
              item["q"] &&
              item["q"] !== "" &&
              item["id"] !== "" &&
              item["cat"]?.toLowerCase() === tableName?.toLowerCase() && (
                <QuestionSection key={index}>
                  <QuestionSection.QuestionTextContainer>
                    <QuestionSection.QuestionLabelContainer>
                      <QuestionSection.QuestionLabel>
                        Q{(Sr_No = Sr_No + 1)}
                      </QuestionSection.QuestionLabel>
                    </QuestionSection.QuestionLabelContainer>
                    <QuestionSection.Question>
                      {item[`q`]}
                    </QuestionSection.Question>
                    <QuestionSection.InfoIconContainer>
                      <FcInfo
                        style={{
                          float: "right",
                          width: "20px",
                          height: "20px",
                        }}
                        onClick={(e) => toast(e, item[`guideline`])}
                      />
                    </QuestionSection.InfoIconContainer>
                  </QuestionSection.QuestionTextContainer>
                  {item.input_type === 4 ? (
                    <>
                      <QuestionSection.MainContainer>
                        <Form.Input
                          type="number"
                          name={`${tableName}_${index}`}
                          id={`${tableName}_${index}`}
                          onChange={(e) => handleChange(e, "", item)}
                          value={def["rating_metadata"]?.[item["id"]]}
                        />
                      </QuestionSection.MainContainer>
                      {rangeObj && (
                        <>
                          {!errors.hasOwnProperty(item["id"]) &&
                          rangeObj["ov_max"] !== rangeObj["ov_min"] &&
                          ratingMetadata?.[item["id"]] >= rangeObj["ov_min"] &&
                          ratingMetadata?.[item["id"]] <= rangeObj["ov_max"] ? (
                            <QuestionSection.MainContainer>
                              <QuestionSection.AnswerContainer>
                                {tempJSON[item["id"]] === "not_ok" ? (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) =>
                                      handleChange(e, "not_ok", item)
                                    }
                                    styleAttributes={{
                                      backgroundColor: "#FF5471",
                                      color: "#FFFF",
                                      borderColor: "#FF5471",
                                    }}
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                    <QuestionSection.Answer>
                                      NOT OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                ) : (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) =>
                                      handleChange(e, "not_ok", item)
                                    }
                                    styleAttributes={{ borderColor: "#FF5471" }}
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                    <QuestionSection.Answer>
                                      NOT OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                )}
                                {tempJSON[item["id"]] === "ok" ? (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "ok", item)}
                                    styleAttributes={{
                                      backgroundColor: "#3BE656",
                                      color: "#FFFF",
                                      borderColor: "#3BE656",
                                    }}
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                    <QuestionSection.Answer>
                                      ALL OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                ) : (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "ok", item)}
                                    styleAttributes={{ borderColor: "#3BE656" }}
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                    <QuestionSection.Answer>
                                      ALL OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                )}
                              </QuestionSection.AnswerContainer>
                            </QuestionSection.MainContainer>
                          ) : !errors.hasOwnProperty(item["id"]) &&
                            rangeObj["ov_max"] !== rangeObj["ov_min"] &&
                            ratingMetadata[[item["id"]]] !== "" &&
                            ((ratingMetadata?.[item["id"]] >= rangeObj["min"] &&
                              ratingMetadata?.[item["id"]] <
                                rangeObj["ov_min"]) ||
                              (ratingMetadata?.[item["id"]] >
                                rangeObj["ov_max"] &&
                                ratingMetadata?.[item["id"]] <=
                                  rangeObj["max"])) ? (
                            <QuestionSection.MainContainer>
                              <QuestionSection.AnswerContainer>
                                {ratingMetadata?.[item["id"]] >=
                                  rangeObj["min"] &&
                                ratingMetadata?.[item["id"]] <
                                  rangeObj["ov_min"] ? (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "", item)}
                                    styleAttributes={{
                                      backgroundColor: "#FF5471",
                                      color: "#FFFF",
                                      borderColor: "#FF5471",
                                    }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                    <QuestionSection.Answer>
                                      NOT OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                ) : (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "", item)}
                                    styleAttributes={{ borderColor: "#FF5471" }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                    <QuestionSection.Answer>
                                      NOT OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                )}
                                {ratingMetadata?.[item["id"]] >
                                  rangeObj["ov_max"] &&
                                ratingMetadata?.[item["id"]] <=
                                  rangeObj["max"] ? (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "", item)}
                                    styleAttributes={{
                                      backgroundColor: "#3BE656",
                                      color: "#FFFF",
                                      borderColor: "#3BE656",
                                    }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                    <QuestionSection.Answer>
                                      ALL OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                ) : (
                                  <QuestionSection.AnswerIconContainer
                                    onClick={(e) => handleChange(e, "", item)}
                                    styleAttributes={{ borderColor: "#3BE656" }}
                                    disabled
                                  >
                                    <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                    <QuestionSection.Answer>
                                      ALL OK
                                    </QuestionSection.Answer>
                                  </QuestionSection.AnswerIconContainer>
                                )}
                              </QuestionSection.AnswerContainer>
                            </QuestionSection.MainContainer>
                          ) : (
                            ""
                          )}
                        </>
                      )}

                      {rangeObj && (
                        <>
                          {!errors.hasOwnProperty(item["id"]) &&
                            rangeObj["ov_max"] === rangeObj["ov_min"] &&
                            ratingMetadata[[item["id"]]] !== "" &&
                            ((ratingMetadata?.[item["id"]] >= rangeObj["min"] &&
                              ratingMetadata?.[item["id"]] <
                                rangeObj["ov_min"]) ||
                              (ratingMetadata?.[item["id"]] >=
                                rangeObj["ov_max"] &&
                                ratingMetadata?.[item["id"]] <=
                                  rangeObj["max"])) && (
                              <QuestionSection.MainContainer>
                                <QuestionSection.AnswerContainer>
                                  {ratingMetadata?.[item["id"]] >=
                                    rangeObj["min"] &&
                                  ratingMetadata?.[item["id"]] <
                                    rangeObj["ov_min"] ? (
                                    <QuestionSection.AnswerIconContainer
                                      onClick={(e) => handleChange(e, "", item)}
                                      styleAttributes={{
                                        backgroundColor: "#FF5471",
                                        color: "#FFFF",
                                        borderColor: "#FF5471",
                                      }}
                                      disabled
                                    >
                                      <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                      <QuestionSection.Answer>
                                        NOT OK
                                      </QuestionSection.Answer>
                                    </QuestionSection.AnswerIconContainer>
                                  ) : (
                                    <QuestionSection.AnswerIconContainer
                                      onClick={(e) => handleChange(e, "", item)}
                                      styleAttributes={{
                                        borderColor: "#FF5471",
                                      }}
                                      disabled
                                    >
                                      <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                                      <QuestionSection.Answer>
                                        NOT OK
                                      </QuestionSection.Answer>
                                    </QuestionSection.AnswerIconContainer>
                                  )}
                                  {ratingMetadata?.[item["id"]] >=
                                    rangeObj["ov_max"] &&
                                  ratingMetadata?.[item["id"]] <=
                                    rangeObj["max"] ? (
                                    <QuestionSection.AnswerIconContainer
                                      onClick={(e) => handleChange(e, "", item)}
                                      styleAttributes={{
                                        backgroundColor: "#3BE656",
                                        color: "#FFFF",
                                        borderColor: "#3BE656",
                                      }}
                                      disabled
                                    >
                                      <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                      <QuestionSection.Answer>
                                        ALL OK
                                      </QuestionSection.Answer>
                                    </QuestionSection.AnswerIconContainer>
                                  ) : (
                                    <QuestionSection.AnswerIconContainer
                                      onClick={(e) => handleChange(e, "", item)}
                                      styleAttributes={{
                                        borderColor: "#3BE656",
                                      }}
                                      disabled
                                    >
                                      <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                                      <QuestionSection.Answer>
                                        ALL OK
                                      </QuestionSection.Answer>
                                    </QuestionSection.AnswerIconContainer>
                                  )}
                                </QuestionSection.AnswerContainer>
                              </QuestionSection.MainContainer>
                            )}
                        </>
                      )}
                    </>
                  ) : (
                    <QuestionSection.MainContainer>
                      <QuestionSection.AnswerContainer>
                        {tempJSON[item["id"]] === "not_ok" ? (
                          <QuestionSection.AnswerIconContainer
                            onClick={(e) => handleChange(e, "not_ok", item)}
                            styleAttributes={{
                              backgroundColor: "#FF5471",
                              color: "#FFFF",
                              borderColor: "#FF5471",
                            }}
                          >
                            <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                            <QuestionSection.Answer>
                              NOT OK
                            </QuestionSection.Answer>
                          </QuestionSection.AnswerIconContainer>
                        ) : (
                          <QuestionSection.AnswerIconContainer
                            onClick={(e) => handleChange(e, "not_ok", item)}
                            styleAttributes={{ borderColor: "#FF5471" }}
                          >
                            <QuestionSection.AnswerIcon src="../assets/answer/thumpsDown.svg" />
                            <QuestionSection.Answer>
                              NOT OK
                            </QuestionSection.Answer>
                          </QuestionSection.AnswerIconContainer>
                        )}

                        {tempJSON[item["id"]] === "ok" ? (
                          <QuestionSection.AnswerIconContainer
                            onClick={(e) => handleChange(e, "ok", item)}
                            styleAttributes={{
                              backgroundColor: "#3BE656",
                              color: "#FFFF",
                              borderColor: "#3BE656",
                            }}
                          >
                            <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                            <QuestionSection.Answer>
                              ALL OK
                            </QuestionSection.Answer>
                          </QuestionSection.AnswerIconContainer>
                        ) : (
                          <QuestionSection.AnswerIconContainer
                            onClick={(e) => handleChange(e, "ok", item)}
                            styleAttributes={{ borderColor: "#3BE656" }}
                          >
                            <QuestionSection.AnswerIcon src="../assets/answer/thumpsUp.svg" />
                            <QuestionSection.Answer>
                              ALL OK
                            </QuestionSection.Answer>
                          </QuestionSection.AnswerIconContainer>
                        )}
                      </QuestionSection.AnswerContainer>
                    </QuestionSection.MainContainer>
                  )}
                  <div style={{ marginBottom: "10px" }}></div>
                  {errors?.hasOwnProperty(`${item["id"]}`) && (
                    <h5 style={{ color: "red", marginTop: "2px" }}>
                      {errors[`${item["id"]}`]}
                    </h5>
                  )}
                </QuestionSection>
              )
            );
          })
        )}
      </div>
    </>
  );
}
